import { styled, svgIconClasses } from "@mui/material";
import { colorPickerName } from "../../../classes.js";
import { borderWidth, Chip } from "./Chip.js";
const NoColorChip = styled(Chip, {
  name: colorPickerName,
  slot: "SwatchNoColor"
})(({ theme, size }) => {
  return {
    backgroundColor: theme.palette.common.white,
    [`& .${svgIconClasses.root}`]: {
      fontSize: size - borderWidth * 2,
      opacity: 1,
      scale: "1",
      transition: "opacity 0.18s ease, scale 0.25s ease"
    }
  };
});
export {
  NoColorChip
};
//# sourceMappingURL=NoColorChip.js.map
